import React from 'react';

interface OKomBreadcrumbProps {
    path: string;
}

const OKomBreadcrumb: React.FC<OKomBreadcrumbProps> = ({ path }) => {
    const linkTargets: Record<string, string> = {
        'Klasseoversikt': '/classes/1',
        'Rapporter': '/reports',
        'Felles epost': '/fellesepost',
    };

    const items = path.split(',').map((item, index) => {
        const label = item.trim();
        const href = linkTargets[label];
        return (
            <li key={index} className="ods-breadcrumb__item">
                {href ? (
                    <a className="ods-breadcrumb__link" href={href}>{label}</a>
                ) : (
                    <span className="ods-breadcrumb__link">{label}</span>
                )}
            </li>
        );
    });

    return (
        <div className="ods-grid__column--12 ods-padding-6">
            <nav className="ods-breadcrumb" aria-label="Breadcrumb">
                <ul className="ods-breadcrumb__list">
                    <li className="ods-breadcrumb__item">
                        <a className="ods-breadcrumb__link" href="/">Hjem</a>
                    </li>
                    {items}
                </ul>
            </nav>
        </div>
    );
};

export default OKomBreadcrumb;
